import { defineMessages } from 'react-intl';

const messages = defineMessages({
  regularAssistancePayments: {
    id: 'App.ManageHudVoucherDetails.Accounting.RegularAssistancePayments',
    defaultMessage: 'Regular Assistance Payments',
  },
  tableTitle: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.TableTitle',
    defaultMessage: 'Regular Assistance Payments',
  },
  emptyStateMessage: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.EmptyStateMessage',
    defaultMessage: 'No regular assistance payments found.',
  },
  status: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.Column.Status',
    defaultMessage: 'Status',
  },
  headOfHousehold: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.Column.HeadOfHousehold',
    defaultMessage: 'Head of Household',
  },
  unit: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.Column.Unit',
    defaultMessage: 'Unit',
  },
  hudUnitNumber: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.Column.HudUnitNumber',
    defaultMessage: 'HUD Unit #',
  },
  hudUnitNumberTooltip: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.Column.HudUnitNumberTooltip',
    defaultMessage:
      'If the HUD Contract Unit # differs from Fortress, it will appear here (if entered) ' +
      'and be reflected on the voucher sent to TRACS. To add one, open the unit and enter ' +
      'the HUD Unit # in General Unit Information.',
  },
  bedsBaths: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.Column.BedsBaths',
    defaultMessage: 'Beds / Baths',
  },
  contractRent: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.Column.ContractRent',
    defaultMessage: 'Contract Rent',
  },
  utilityAllowance: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.Column.UtilityAllowance',
    defaultMessage: 'Utility Allowance',
  },
  grossRent: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.Column.GrossRent',
    defaultMessage: 'Gross Rent',
  },
  incomeCode: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.Column.IncomeCode',
    defaultMessage: 'Income Code',
  },
  turnoverCode: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.Column.TurnoverCode',
    defaultMessage: 'Turnover Code',
  },
  turnoverMonthDay: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.Column.TurnoverMonthDay',
    defaultMessage: 'Turnover Month/Day',
  },
  nextRecertDate: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.Column.NextRecertDate',
    defaultMessage: 'Next Recert Date',
  },
  dateFirstRecertReminderNoticeSent: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.Column.DateFirstRecertReminderNoticeSent',
    defaultMessage: 'Date 1st Reminder Notice Sent',
  },
  changeCode: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.Column.ChangeCode',
    defaultMessage: 'Change Code',
  },
  requestedAmount: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.Column.RequestedAmount',
    defaultMessage: 'Requested Amount',
  },
  approvedAmount: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.Column.ApprovedAmount',
    defaultMessage: 'Approved Amount',
  },
  validationState: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.Column.ValidationState',
    defaultMessage: 'Validation State',
  },
  payable: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.Column.Payable',
    defaultMessage: 'Payable',
  },
  deriveAction: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.DeriveAction',
    defaultMessage: 'Refresh Regular Assistance',
  },
  deriveSuccess: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.DeriveSuccess',
    defaultMessage: 'Regular Assistance was refreshed.',
  },
  deriveError: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.DeriveError',
    defaultMessage: 'Failed to refresh Regular Assistance. Please try again.',
  },
  validationBlockingBanner: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.ValidationBlockingBanner',
    defaultMessage:
      'Regular Assistance has validation issues that must be resolved before submission.',
  },
  updateApprovedAmountSuccess: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.UpdateApprovedAmountSuccess',
    defaultMessage: 'Approved amount updated successfully.',
  },
  updateApprovedAmountError: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.UpdateApprovedAmountError',
    defaultMessage: 'Unable to update approved amount. Please try again.',
  },
  somethingOffBanner: {
    id: 'App.ManageHudVoucherDetails.RegularAssistancePayments.SomethingOffBanner',
    defaultMessage:
      'Seeing something off? Make sure all eligible New Tenant Events are completed and submitted—' +
      'Regular Assistance will update for the applicable unit(s) once submitted.\n' +
      'Move Out certs must be completed before the unit will appear Vacant below.',
  },
});

export default messages;
